import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ListEnd, Pencil, TextAlignJustify, UserIcon } from "lucide-react";
import { openCreatePicker } from "@components/CreateOptionPickerCst/host";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { Box, Typography } from "@mui/material";
import SectionWrapper from "./SectionWrapper";
import SectionHeader from "./SectionHeader";
import UserGroupsTabs from "./UsersGroupsTabs";
import UsersPanel from "./UsersPanel";
import GroupsPanel from "./GroupsPanel";
import LatestTrainingOfferings from "./LatestTrainingOfferings";

export default function MySpace() {
  const { t } = useTranslation("my-space");
  const to = useNavigate();
  const { id: corporateId = "" } = useParams();
  return (
    <AnimationFadeIn>
      <Box sx={{ py: 3, pr: 3 }}>
        <Typography
          sx={{
            fontSize: "28px",
            fontWeight: 700,
            color: (theme) => theme.palette.text.primary,
          }}
        >
          {t("title")}
        </Typography>
        <Typography
          sx={{
            fontSize: "13px",
            color: (theme) => theme.palette.text.primary,
            mt: 0.5,
          }}
        >
          {t("subtitle")}
        </Typography>
        <SectionWrapper>
          <SectionHeader
            title={t("latest-training-offers.title")}
            subtitle={t("latest-training-offers.subtitle")}
            actions={[
              {
                variant: "outlined",
                label: t("header.see-all"),
                onClick: () => {
                  to(`/v2/corporate/${corporateId}/detail/catalog`);
                },
              },
              {
                variant: "contained",
                label: t("header.create"),
                startIcon: <Pencil size={14} />,
                onClick: () => {
                  openCreatePicker("catalog");
                },
              },
            ]}
          />
          <LatestTrainingOfferings showDetailsButton={false} />
        </SectionWrapper>
        <SectionWrapper>
          <SectionHeader
            title={t("latest-users-and-groups.title")}
            subtitle={t("latest-users-and-groups.subtitle")}
            actions={[
              {
                variant: "outlined",
                label: t("header.see-all"),
                onClick: () => {
                  to(`/v2/corporate/${corporateId}/detail/users-groups`);
                },
              },
              {
                variant: "contained",
                label: t("header.create"),
                startIcon: <Pencil size={14} />,
                onClick: () => {
                  openCreatePicker("users-groups");
                },
              },
            ]}
          />
          <UserGroupsTabs
            tabs={[
              {
                id: "users",
                label: t("latest-users-and-groups.tabs.users"),
                icon: <UserIcon />,
                panel: <UsersPanel />,
              },
              {
                id: "static-groups",
                label: t("latest-users-and-groups.tabs.static-groups"),
                icon: <TextAlignJustify />,
                panel: <GroupsPanel tab="static-groups" />,
              },
              {
                id: "dynamic-groups",
                label: t("latest-users-and-groups.tabs.dynamic-groups"),
                icon: <ListEnd />,
                panel: <GroupsPanel tab="dynamic-groups" />,
              },
            ]}
          />
        </SectionWrapper>
      </Box>
    </AnimationFadeIn>
  );
}
